// A viewer session, never an Ant Media administration/publishing credential.
// Production sessions must be issued by the authenticated .NET backend.
export type PlaybackSource =
  | {kind:'local-preview'; sessionId:string}
  | {kind:'antmedia'; sessionId:string; playerUrl:string; playToken?:string; expiresAtUtc?:string};
export type PlaybackStatus = 'idle'|'connecting'|'embedded'|'playing'|'buffering'|'retrying'|'blocked'|'ended'|'error'|'expired';
export type PlaybackIssue = {code:'connection'|'unsupported'|'authorization'|'invalidSource'|'expired'; retryable:boolean};

export function validatePlaybackSource(source:PlaybackSource, pageProtocol=location.protocol): PlaybackIssue|null {
  const invalid:PlaybackIssue={code:'invalidSource',retryable:false};
  if(!source.sessionId?.trim())return invalid;
  if(source.kind==='local-preview')return null;
  if(source.expiresAtUtc){const expires=Date.parse(source.expiresAtUtc);if(!Number.isFinite(expires))return invalid;if(expires<=Date.now())return {code:'expired',retryable:false};}
  try{
    const url=new URL(source.playerUrl);
    if(url.username||url.password||url.hash)return invalid;
    if(!['http:','https:'].includes(url.protocol)||(pageProtocol==='https:'&&url.protocol!=='https:'))return invalid;
    const streamId=url.searchParams.get('id')||url.searchParams.get('name');
    if(!url.pathname.endsWith('/play.html')||!streamId||streamId.length>256||/[\s?#\\]/u.test(streamId))return invalid;
    return null;
  }catch{return invalid;}
}

export function antMediaEmbedUrl(source:Extract<PlaybackSource,{kind:'antmedia'}>):string{
  const url=new URL(source.playerUrl);
  // Preserve Ant Media's own configured playback order, controls and options.
  // Only supply documented startup defaults when the supplied URL has no value.
  if(!url.searchParams.has('autoplay'))url.searchParams.set('autoplay','true');
  if(!url.searchParams.has('mute'))url.searchParams.set('mute','true');
  if(source.playToken)url.searchParams.set('token',source.playToken);
  return url.toString();
}
